export default __webpack_public_path__ + "static/media/reward-1.e8ffab5d.png";